import { render, staticRenderFns } from "./SifreSifirlama.vue?vue&type=template&id=5a8f51d4&"
import script from "./SifreSifirlama.vue?vue&type=script&lang=js&"
export * from "./SifreSifirlama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports